module.exports = __webpack_public_path__ + "static/media/335.6f939c44.png";